import { Tooltip, Typography } from '@mui/material';
import { useClipboard } from 'use-clipboard-copy';
import React, { FC, useState } from 'react';

import { CommentIdWithTooltipProps } from '../types';

const CommentIdWithTooltip: FC<CommentIdWithTooltipProps> = ({ commentId }) => {
    const [copied, setCopied] = useState(false);
    const { copy } = useClipboard();

    const handleCopy = () => {
        copy(String(commentId));
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
    };

    return (
        <Tooltip title={copied && 'Copied!'} placement="top">
            <Typography
                variant="subtitle2"
                color="secondary"
                sx={{
                    opacity: 0.66,
                    cursor: 'pointer',
                    ml: 'auto',
                    display: 'block',
                    userSelect: 'all',
                }}
                component="span"
                tabIndex={0}
                role="button"
                onClick={handleCopy}
            >
                #{commentId}
            </Typography>
        </Tooltip>
    );
};

export default CommentIdWithTooltip;
